import {Component, Input, OnInit} from '@angular/core';
import {BaseModal} from '@ui-app/modals/base-modal';
import * as EmployeeModels from '@employee-models/index';
import {IRequestListGridRequest} from '@employee-models/data.models';
import {BadgeStatusEnum} from '@employee-models/data.enums';
import {ProfileRequestsFilterItems} from '@employee-models/common.models';

interface FilterItem {
    id: string;
    value: string;
    checked: boolean;
}

interface FilterItems {
    [key: string]: Array<FilterItem>;
}

@Component({
  selector: 'employee-mobile-request-list-filter-modal',
  templateUrl: './mobile-request-list-filter-modal.component.html',
  styleUrls: ['./mobile-request-list-filter-modal.component.less']
})

export class MobileRequestsListFilterModalComponent extends BaseModal implements OnInit {

    @Input() popupTitle = 'Filter';
    @Input() showButtonNo  = true;
    @Input() showButtonYes = true;
    @Input() buttonsTitle  = {
        dismiss: 'Cancel',
        confirm: 'Apply'
    };
    @Input() gridRequest: IRequestListGridRequest;
    @Input() gridData: EmployeeModels.DM.ITableWithFilterModelGeneric<EmployeeModels.DM.IRequestResponse>;
    @Input() isDefaultFilters: boolean = true;
    @Input() defaultFilters: FilterItems;
    @Input() selectedRequestedDateStart: Date;
    @Input() selectedRequestedDateEnd: Date;

    readonly badgeRequestStatusName = `badgeRequestStatusName`;
    readonly bsConfig = {
        adaptivePosition: true,
        containerClass: 'theme-db-blue',
        rangeInputFormat: 'M/d/y',
        customTodayClass: 'bs-today-custom',
        showWeekNumbers: false,
        useUtc: true
    };
    selectedFilters: EmployeeModels.CM.ProfileRequestsFilterItems;
    requestListFilters: FilterItems;
    selectedRequestedDate: string[] = [];

    constructor() {
        super();
    }

    ngOnInit(): void {
        if (this.isDefaultFilters) {
            this.requestListFilters = this.createDefaulFilterState(this.gridData.filters);
        } else {
            this.requestListFilters = this.defaultFilters;
        }
    }

    applyFiltering(): void {
        this.selectedFilters = this.createSelectedFiltersState(this.requestListFilters);
        const requestedDateStr = this.selectedRequestedDate?.map(item => item ? new Date(item).toUTCString() : '');
        this.gridRequest.columnFilters = {
            badgeRequestReasonName: this.selectedFilters.selectedBadgeRequestReasonName,
            badgeRequestStatusName: this.selectedFilters.selectedBadgeStatus,
            photoRequestStatusName: this.selectedFilters.selectedPhotoStatus,
            requestedDateStr
        };
        const modalPayload = {
            gridRequest: this.gridRequest,
            selectedFilters: {
                columnFilters: this.requestListFilters,
                startDate: this.selectedRequestedDateStart,
                endDate: this.selectedRequestedDateEnd,
            }
        };
        this.action(modalPayload);
    }

    checkSelectedItem(selectedItem: string[], columnName: string): void {
        this.requestListFilters[columnName].forEach(statusItem => {
            statusItem.checked = selectedItem.includes(statusItem.id);
        });
    }

    selectRequestedDate(selectedRequestedDate: string[]): void {
        this.selectedRequestedDate = selectedRequestedDate;
        this.selectedRequestedDateStart = !!selectedRequestedDate && selectedRequestedDate[0] ? new Date(selectedRequestedDate[0]) : null;
        this.selectedRequestedDateEnd = !!selectedRequestedDate && selectedRequestedDate[1] ? new Date(selectedRequestedDate[1]) : null;
    }

    createDefaulFilterState(filters: EmployeeModels.DM.IGridFilters): FilterItems {
        const filterStateObj: FilterItems = {};
        const copyFilters = JSON.parse(JSON.stringify(filters));
        const filtersColumnNames = Object.getOwnPropertyNames(filters);
        filtersColumnNames.forEach(columnName => {
            filterStateObj[columnName] = copyFilters[columnName].map(filterItem => {
                const item = {
                    id: filterItem.key,
                    value: filterItem.value,
                    checked: true
                };
                if (columnName === this.badgeRequestStatusName) {
                    item.checked = [BadgeStatusEnum.Pending.toString()].indexOf(filterItem.key) >= 0;
                }
                return item;
            });
        });
        return filterStateObj;
    }

    createSelectedFiltersState(filters: FilterItems): ProfileRequestsFilterItems {
        return {
            selectedBadgeRequestReasonName: this.getSelectedItemsId(filters.badgeRequestReasonName),
            selectedPhotoStatus: this.getSelectedItemsId(filters.photoRequestStatusName),
            selectedBadgeStatus: this.getSelectedItemsId(filters.badgeRequestStatusName)
        };
    }

    getSelectedItemsId(items: FilterItem[]): string[] {
       return items.filter(item => {
            if (item.checked) {
                return item.id;
            }
        }).map(item => item.id);
    }

}
